import { render, staticRenderFns } from "./AppMessage.vue?vue&type=template&id=681c37cf&scoped=true&"
import script from "./AppMessage.vue?vue&type=script&lang=js&"
export * from "./AppMessage.vue?vue&type=script&lang=js&"
import style0 from "./AppMessage.vue?vue&type=style&index=0&id=681c37cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681c37cf",
  null
  
)

export default component.exports